import { render, staticRenderFns } from "./SiteStats.vue?vue&type=template&id=7be4be96&scoped=true&"
import script from "./SiteStats.vue?vue&type=script&lang=js&"
export * from "./SiteStats.vue?vue&type=script&lang=js&"
import style0 from "./SiteStats.vue?vue&type=style&index=0&id=7be4be96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be4be96",
  null
  
)

export default component.exports